// extracted by mini-css-extract-plugin
module.exports = {"column":"Account_column__2j6Nl","container":"Account_container__2pgyB","rowReverse":"Account_rowReverse__cJtqD"};